import { motion } from "framer-motion"
import { Clock, Shield, Zap, LucideIcon } from "lucide-react"

interface TrustFeature {
  icon: LucideIcon
  label: string
  color: string
}

const features: TrustFeature[] = [
  { icon: Zap, label: "Instant Quote", color: "text-yellow-500" },
  { icon: Shield, label: "100% Secure", color: "text-green-500" },
  { icon: Clock, label: "24/7 Support", color: "text-blue-500" },
]

interface TrustFeaturesProps {
  variants?: any
}

export function TrustFeatures({ variants }: TrustFeaturesProps) {
  return (
    <motion.div className="flex justify-center mt-12" variants={variants}>
      <div className="flex items-center gap-8 bg-white/80 backdrop-blur-sm px-8 py-4 rounded-2xl border border-white/50 shadow-lg">
        {features.map((feature, index) => {
          const FeatureIcon = feature.icon
          return (
            <div key={index} className="flex items-center gap-2">
              <FeatureIcon size={20} className={feature.color} />
              <span className="text-sm font-medium text-foreground">{feature.label}</span>
            </div>
          )
        })}
      </div>
    </motion.div>
  )
}
